import {getAuth} from 'firebase/auth'
import React from 'react'
import {useNotification} from '../../common/notifications/useNotification'
import {IconButton} from '../../webui/IconButton'
import {useTranslatedProduct} from '../product/utils/useTranslatedProduct'
import {AllRentalData} from './types'
import {generateBoxActionInfo} from './utils/generateBoxActionInfo'
import {Tooltip} from '@mui/material'
import {getReactAppServerURL} from '../../common/environment/environmentManager'

interface Props {
  rental: AllRentalData
}

export const PostBoxActionButton: React.FC<Props> = ({rental}) => {
  const {showNotification} = useNotification()
  const {tName} = useTranslatedProduct()

  const onClick = async () => {
    const token = await getAuth().currentUser?.getIdToken()

    const resp = await fetch(`${getReactAppServerURL()}/api/box-action`, {
      method: 'POST',
      headers: {
        authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'x-client-kind': 'admin',
      },
      body: JSON.stringify(generateBoxActionInfo(rental, tName(rental.product, 'sv'))),
    })
    if (resp.status === 200) {
      showNotification({
        message: 'Box action added',
        severity: 'success',
      })
    } else {
      showNotification({
        message: 'Box action could not be added',
        severity: 'error',
      })
    }
  }

  return (
    <Tooltip title="Send this rental to Notion" placement="top-end">
      <IconButton sx={{padding: 0}} onClick={onClick}>
        <img src={`/notion-logo.svg`} alt={'notion-logo'} width={24} height={24} />
      </IconButton>
    </Tooltip>
  )
}
